import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface DuLieuChiTieus {
  name: string;
  api_token: string;
}

export interface DuLieuChiTieusListInfor {
  errors: unknown;
  duLieuChiTieus: DuLieuChiTieus;
  isAuthenticated: boolean;
}

@Module
export default class DuLieuChiTieusModule
  extends VuexModule
  implements DuLieuChiTieusListInfor
{
  errors = {};
  duLieuChiTieus = {} as DuLieuChiTieus;
  isAuthenticated = !!JwtService.getToken();

  get DuLieuChiTieus() {
    return this.duLieuChiTieusListData;
  }

  @Mutation
  [Mutations.DU_LIEU_CHI_TIEUS_LIST_DATA](DuLieuChiTieus) {
    this.duLieuChiTieusListData = DuLieuChiTieus;
  }

  @Action
  [Actions.DU_LIEU_CHI_TIEUS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/solieu_chitieu_tk", payload)
        .then((data) => {
          this.context.commit(Mutations.DU_LIEU_CHI_TIEUS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.DU_LIEU_CHI_TIEU_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("solieu_chitieu_tk/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.DU_LIEU_CHI_TIEUS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.DU_LIEU_CHI_TIEU_UPDATE](payload) {
    const year_month = payload.data.year_month;
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/solieu_chitieu_tk",
        "upsert",
        year_month,
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.DU_LIEU_CHI_TIEUS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.DU_LIEU_CHI_TIEU_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/solieu_chitieu_tk",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.DU_LIEU_CHI_TIEUS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
